const prefix = ''

export const aiSubsystemUrls = {
  aiSubsystem: `${prefix}/AI-subsystem`,
}
